/* tslint:disable */

declare var Object: any;
export interface PropertyUnitFileInterface {
  "property_unit_id": string;
  "file_description": string;
  "file_path": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class PropertyUnitFile implements PropertyUnitFileInterface {
  "property_unit_id": string;
  "file_description": string;
  "file_path": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: PropertyUnitFileInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `PropertyUnitFile`.
   */
  public static getModelName() {
    return "PropertyUnitFile";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of PropertyUnitFile for dynamic purposes.
  **/
  public static factory(data: PropertyUnitFileInterface): PropertyUnitFile{
    return new PropertyUnitFile(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'PropertyUnitFile',
      plural: 'PropertyUnitFiles',
      path: 'PropertyUnitFiles',
      idName: 'id',
      properties: {
        "property_unit_id": {
          name: 'property_unit_id',
          type: 'string'
        },
        "file_description": {
          name: 'file_description',
          type: 'string'
        },
        "file_path": {
          name: 'file_path',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
